import React, { Component } from 'react';

export default class Chapter1 extends Component {
  render() {
    return (
      <div>
        <div className="medium-padding joysetter-header">
          <h6 className="white">Jet Lag Tool Kit</h6>
          <h1 className="white">Chapter 5: Step Outside of the Fire</h1>
          <p className="white"><b>How to get out of the fire so you actually can enjoy the heat</b></p>
        </div>
        <div className="toolkit-content">
          <ol >
            <li>When a situation occurs that brings on an angry (or frustrated/resentful) response, notice the physical change rolling throughout your body. Look at it with a sense of curious observation.
            </li>
            <li>Breathe. Big, full, deep breaths here. Slow exhale.
            </li>
            <li>Say to yourself, ‘Thank you, anger/frustration/resentment, but I choose to let you go now.’
            </li>
            <li>Feel the physical sensations of anger relax and release as you breathe.
            </li>
            <li>If you replay or relive the anger, repeat this process and ask yourself how many of your 86,400 seconds you are willing to spend on that moment.
            </li>
          </ol>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/toolkits/chapter5.js